import { render, staticRenderFns } from "./DwxxbgsqBrowse.vue?vue&type=template&id=44c130da"
import script from "./DwxxbgsqBrowse.vue?vue&type=script&lang=js"
export * from "./DwxxbgsqBrowse.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports